// extracted by mini-css-extract-plugin
export default {"mainContainer":"ResultItem_mainContainer__UXmOh","name":"ResultItem_name__W30uh","buttonContainer":"ResultItem_buttonContainer__hUrvU"};